import { useQuery } from "@tanstack/react-query";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { NeverSoldProductsListItem } from "../../insights.types";
import { requestNeverSoldProducts } from "./neverSoldProducts.request";

const useNeverSoldProducts = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<NeverSoldProductsListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["products", "never-sold", requestParams],
    queryFn: async () => await requestNeverSoldProducts(requestParams),
    ...options
  });

  return { neverSoldProducts: data?.data, meta: data?.meta, ...rest };
};

export default useNeverSoldProducts;
